import React, {FC, useEffect} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {useFormik} from 'formik'
import {IHrProcessModel, initialHrProcess, validationHrProcess} from './HrProcessModel'

type Props = {
  show: boolean
  editingItem: IHrProcessModel | null
  loading: boolean
  onClose: () => void
  onSubmit: (name: string) => void
}

export const HrProcessFormModal: FC<Props> = ({show, editingItem, loading, onClose, onSubmit}) => {
  const isEditing = !!editingItem

  const formik = useFormik<IHrProcessModel>({
    initialValues: initialHrProcess,
    validationSchema: validationHrProcess,
    onSubmit: (values) => onSubmit(values.name.trim()),
  })

  // Modal her açıldığında formu yeni kayıt / düzenlenen kayıt ile doldur
  useEffect(() => {
    if (!show) return
    formik.resetForm({
      values: editingItem ? {id: editingItem.id, name: editingItem.name} : initialHrProcess,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, editingItem])

  return (
    <Modal show={show} onHide={onClose} dialogClassName='modal-dialog-centered' backdrop='static'>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-header'>
          <h5 className='modal-title'>{isEditing ? 'Süreç Düzenle' : 'Yeni Süreç'}</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>

        <div className='modal-body'>
          <label className='form-label fw-bold required'>Süreç Adı</label>
          <input
            type='text'
            autoFocus
            className={`form-control ${
              formik.touched.name && formik.errors.name ? 'is-invalid' : ''
            }`}
            placeholder='Örn: Yazılım Uzmanı Süreci'
            {...formik.getFieldProps('name')}
          />
          {formik.touched.name && formik.errors.name && (
            <div className='invalid-feedback'>{formik.errors.name}</div>
          )}
        </div>

        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            İptal
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {loading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Lütfen bekleyin...
                <span className='spinner-border spinner-border-sm align-middle ms-2' />
              </span>
            ) : isEditing ? (
              'Güncelle'
            ) : (
              'Kaydet'
            )}
          </button>
        </div>
      </form>
    </Modal>
  )
}
